import { Field, Float, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateId } from '@ztechapps/common.utils'
import { InvoicePaymentItem } from './InvoicePaymentItem'

@ObjectType()
export class InvoicePayment {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateId() })
  _id: string

  @Field(() => Float)
  @Prop({ type: Number })
  total: number

  @Field(() => Float)
  @Prop({ type: Number })
  balance: number

  @Field(() => [InvoicePaymentItem])
  @Prop({ type: () => [InvoicePaymentItem] })
  items: InvoicePaymentItem[]
}
